import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const defaultTo = dayjs().endOf('day').toISOString();
const defaultFrom = dayjs().subtract(1, 'month').startOf('day').toISOString();

const initialState = {
  from: defaultFrom,
  to: defaultTo,
};

export type UserStatsState = Readonly<typeof initialState>;

export const slice = createSlice({
  name: 'userStats',
  initialState,
  reducers: {
    setFrom: (state, action: PayloadAction<string>) => {
      state.from = action.payload;
    },
    setTo: (state, action: PayloadAction<string>) => {
      state.to = action.payload;
    },
    reset: state => {
      state.from = defaultFrom;
      state.to = defaultTo;
    },
  },
});

export const { reset, setFrom, setTo } = slice.actions;

export default slice.reducer;
